const NotificationsTypeEnum = {
  REPORT: 'REPORT',
  BUG: 'BUG',
  INFO: 'INFO',
  WARNING: 'WARNING',
};

export default NotificationsTypeEnum;
